import { render, staticRenderFns } from "./Businessmen.vue?vue&type=template&id=dd94df46&"
import script from "./Businessmen.vue?vue&type=script&lang=js&"
export * from "./Businessmen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports